import React from "react"

const Row = ({ children, className}) => {
  if (!className){className=""} else className = " " + className
  return <div className={`row${className}`}>{children}</div>
}
export default Row
